export const FREE_SHIPPING_BANNER_HEIGHT = 36;
